// extracted by mini-css-extract-plugin
export default {"image":"v0IPR","title":"l3qVm","description":"bGs6n","params":"n6BOM","param":"aUqdU"};